import { render, staticRenderFns } from "./orderGoodsView.vue?vue&type=template&id=1952ca27&"
import script from "./orderGoodsView.vue?vue&type=script&lang=js&"
export * from "./orderGoodsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports